import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { schemaHasReverseManyToMany } from './schema-has-reverse-many-to-many.js'

export function shouldEmitJunction(
  currentSchemaName: string,
  field: SchemaField,
  relatedSchemas: Map<string, Schema>
): boolean {
  const relationship = field.relationship
  if (!relationship) {
    return false
  }

  if (isUserRelationshipTarget(relationship)) {
    return true
  }

  const targetSchema = relatedSchemas.get(relationship)
  if (!targetSchema) {
    throw new Error(
      `Missing relationship schema "${relationship}" referenced by "${currentSchemaName}".`
    )
  }

  const hasReverse = schemaHasReverseManyToMany(targetSchema, currentSchemaName)
  if (!hasReverse) {
    return true
  }

  return currentSchemaName.localeCompare(relationship) <= 0
}
